import React from "react";

interface CurrencyProps {
  value: number;
  currency: string;
}

/**
 * Currency component - displays a formatted currency value
 * @param value - The numeric value to format
 * @param currency - The ISO currency code (e.g., 'EUR', 'USD')
 */
const Currency: React.FC<CurrencyProps> = ({ value, currency }) => {
  const formattedValue = value.toLocaleString(undefined, {
    style: "currency",
    currency: currency,
  });

  return <span>{formattedValue}</span>;
};

export default Currency;

